import { useEffect, useState } from "react";

interface IUseDelayedLoaderProps {
  isLoading: boolean;
  showAfterMs?: number;
}

export function useDelayedLoader({
  isLoading,
  showAfterMs = 200,
}: IUseDelayedLoaderProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;

    if (isLoading) {
      timeoutId = globalThis.setTimeout(() => setIsVisible(true), showAfterMs);
    } else {
      setIsVisible(false);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isLoading, showAfterMs]);

  return isVisible;
}
